// Module
var code = `<template> <div class="page-mep-scenario-planning"> <compose view-model.bind="filterViewModel" if.bind="filterViewModel"></compose> <tabs tabs.bind="tabs" view-model.ref="tabsVM" current-tab.two-way="currentTab" tab-changed.delegate="tabChanged(\$event)"></tabs> <compose view-model.bind="currentTab.vm"></compose> </div> </template>`;
// Exports
module.exports = code;